import React, { useEffect, useState } from "react";
import Hero from "../components/Hero";
import BenefitStrip from "../components/BenefitStrip";
import FeaturedProduct from "../components/FeaturedProduct";
import USPSection from "../components/USPSection";
import GripSystem from "../components/GripSystem";
import ColourMatching from "../components/ColourMatching";
import BundlesSection from "../components/BundlesSection";
import TeamOrdersCTA from "../components/TeamOrdersCTA";
import BrandSection from "../components/BrandSection";
import SocialGrid from "../components/SocialGrid";
import EmailCapture from "../components/EmailCapture";
import { fetchProduct, fetchBundles } from "../lib/api";
import useSeo from "../hooks/useSeo";

const HomePage = () => {
  const [product, setProduct] = useState(null);
  const [bundles, setBundles] = useState([]);

  useEffect(() => {
    fetchProduct().then(setProduct).catch(() => {});
    fetchBundles().then(setBundles).catch(() => {});
  }, []);

  useSeo({
    title: "Premium Football Grip Socks",
    description:
      "Football grip socks engineered for boot-lock fit, close touch and clean matchday style. 12 colourways. Designed for academy, semi-pro and serious footballers.",
    path: "/",
    jsonLdId: "home-jsonld",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Pritch — Premium Pitch Wear",
      url: "https://pritch.fc/",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://pritch.fc/shop?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
  });

  return (
    <div data-testid="home-page">
      <Hero />
      <BenefitStrip />
      <FeaturedProduct product={product} />
      <USPSection />
      <GripSystem grips={product?.grips || []} />
      <ColourMatching colourways={product?.colourways || []} />
      <BundlesSection bundles={bundles} />
      <TeamOrdersCTA />
      <BrandSection />
      <SocialGrid />
      <EmailCapture />
    </div>
  );
};

export default HomePage;
